module.exports = __webpack_public_path__ + "b5b269a33b7efab08511c73b791c6f1f.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/saaspass-users/users-side-menu/users-side-menu.html
// module id = 2230
// module chunks = 0